import { z } from 'zod'
import typeguard from 'src/shared/typeguard'


export const activeUserSchema = z.object({
  name: z.string(),
  token: z.string(),
  computer: z.string(),
  rights: z.array(z.string()),
})
export type activeUser = z.infer<typeof activeUserSchema>
export const isActiveUser = typeguard<activeUser>(activeUserSchema)